export default "__VITE_ASSET__c1986045__"